import React from 'react';
import {IDealerResultResponse} from "./data/interfaces";

interface IDealerResultsResponseList {
    results:IDealerResultResponse[]
}
const DealersResult = (dealers:IDealerResultsResponseList) => {
    return (
        <>

             <div className={'flex flex-col'}>
                 {
                     dealers && dealers.results.length > 0 &&
                     <ul className={'grid gap-12 grid-cols-1 md:grid-cols-3'}>
                         {
                            dealers.results.map((dealer) => {return (
                             <li key={dealer.itemGUID} className={'items-start justify-start w-full'}>
                                 <div className="font-bold">{dealer.dealerName}</div>
                                 { dealer.address && <div>{dealer.address}</div> }
                                 {
                                     dealer.city && (
                                         <div>
                                             <span>{dealer.city}</span>
                                             { dealer.state && <span> {dealer.state} </span> }
                                             { dealer.zipCode && <span> {dealer.zipCode} </span> }
                                         </div>
                                     )
                                 }
                                 { dealer.country && <div>{dealer.country}</div> }

                                 { dealer.tel1 && <div>Tel: {dealer.tel1}</div> }
                                 { dealer.tel2 && <div>Tel: {dealer.tel2}</div> }
                                 { dealer.fax && <div>Fax: {dealer.fax}</div> }
                                 { dealer.cellphone && <div>Cell: {dealer.cellphone}</div> }

                                 { dealer.email1 && <div><a href={`mailto:${dealer.email1}`}>{dealer.email1}</a></div> }
                                 { dealer.email2 && <div><a href={`mailto:${dealer.email2}`}>{dealer.email2}</a></div> }
                                 { dealer.email3 && <div><a href={`mailto:${dealer.email3}`}>{dealer.email3}</a></div> }

                                 { dealer.website && <div><a href={dealer.website} title={dealer.website} rel='noreferrer' target="_blank">{dealer.website}</a></div> }
                             </li>
                             )}
                            )
                         }
                    </ul>
                }
             </div>
        </>
    )
}

export default DealersResult;